import { ActionTableSortParamsType } from '../types/table/ActionTableSortParamsType';

export const handleSorting = <T extends Record<string, string | number>>(
  column: string,
  sortParams: ActionTableSortParamsType,
  filteredClients: T[],
  setSortParams: (sortParams: ActionTableSortParamsType) => void,
  setFilteredClients: (list: T[]) => void
) => {
  const isReverse = column === sortParams.column ? !sortParams.isAsc : false;
  setSortParams({ ...sortParams, column: column, isAsc: isReverse });

  const sortedList = [...filteredClients].sort((a, b) => {
    const result = compare(a[column], b[column]);
    return isReverse ? -result : result;
  });

  setFilteredClients(sortedList);
};

function compare(a: string | number | undefined, b: string | number | undefined): number {
  if (a === undefined && b === undefined) return 0;
  if (a === undefined) return -1;
  if (b === undefined) return 1;

  return a < b ? -1 : a > b ? 1 : 0;
}
